<template>
<div class="chapter">
<div class="inner_page">
<p class="img" id="map"><img alt="image" height="600" src="images/pg16.jpg" width="427"/></p>
<p class="img"><img alt="image" height="600" src="images/pg17.jpg" width="429"/></p>
<p class="img"><img alt="image" height="600" src="images/pg18.jpg" width="445"/></p>
<p class="img"><img alt="image" height="600" src="images/pg19.jpg" width="413"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map.vue?d69e7920